import React, { useContext } from "react";
import PropTypes from "prop-types";
import UserPrefsContext from "../../../context/UserPrefs/UserPrefsContext";

import Select from "../../shared/InputElements/Select";
import { useIntl } from "react-intl";

const SelectMinimumOutput = ({ id = "select-charger-brand-filter", chargers, ...rest }) => {
     const intl = useIntl();
     const userPrefs = useContext(UserPrefsContext);
     const label = intl.formatMessage
          ? intl.formatMessage({ id: "minimumOutput", defaultMessage: "Minimum Output" })
          : "Minimum Output";

     const optionNames = [
          "<= 1 kW",
          "<= 10 kW",
          "<= 20 kW",
          "<= 50 kW",
          intl.formatMessage({ id: "all", defaultMessage: "All" }),
     ];
     const optionValues = ["1", "10", "20", "50", "all"];

     return (
          <Select
               id={id}
               value={userPrefs.get("chargerMinPowerOutputKw")}
               label={label}
               optionNames={optionNames}
               optionValues={optionValues}
               handler={(e) => userPrefs.set({ chargerMinPowerOutputKw: e.target.value })}
          />
     );
};

export default SelectMinimumOutput;

SelectMinimumOutput.propTypes = {
     id: PropTypes.string,
     label: PropTypes.string,
};
